import { render } from "./BonusDetails.vue?vue&type=template&id=11ca6d92&scoped=true"
import script from "./BonusDetails.vue?vue&type=script&lang=js"
export * from "./BonusDetails.vue?vue&type=script&lang=js"

import "./BonusDetails.vue?vue&type=style&index=0&id=11ca6d92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ca6d92"]])

export default __exports__